module.exports = __webpack_public_path__ + "img/bce-logo-188.e6d99ce6.png";